import { Component, OnInit } from '@angular/core';
import moment from 'moment';
import { FilterService } from 'primeng/api';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import { PointStoreNavigationBarService } from '../../services/point-store-navigation-bar.service';
import { PointStoreProductValidationService } from '../../services/point-store-product-validation.service';

@Component({
    selector: 'cv-point-store-navigation-bar',
    templateUrl: './point-store-navigation-bar.component.html',
    styleUrls: ['./point-store-navigation-bar.component.scss']
})
export class PointStoreNavigationBarComponent implements OnInit {

    psnbs: any = null;

    constructor(
        private cvLocalizationService: CVLocalizationService,
        private pointStoreNavigationBarService: PointStoreNavigationBarService,
        private pointStoreProductValidationService: PointStoreProductValidationService
    ) { }

    ngOnInit(): void {
        this.psnbs = this.pointStoreNavigationBarService.data;
        this.pointStoreProductValidationService.loadMessages();
    }

    async setEditFrame(index) {
        let currentFrame = this.pointStoreNavigationBarService.getSelectedFrame();
        let validation = this.pointStoreProductValidationService.getValidationOfStep(currentFrame);
        if (validation.succeeded) {
            this.pointStoreNavigationBarService.setSelectedFrame(index);
        } else {
            let validationVal = await this.pointStoreProductValidationService.showValidationErrorDialog(validation);
            const response = String(validationVal);
            if (response == "yes") {
                this.pointStoreNavigationBarService.setSelectedFrame(index);
            } else if (response === 'ok') {
                //if validation triggered in upload picture step and validation.skip is true
                if (validation.skip) {
                    this.pointStoreNavigationBarService.setSelectedFrame(3);
                    return;
                }
                this.pointStoreNavigationBarService.setSelectedFrame(currentFrame);
            }
        }
    }
}
